import { render, staticRenderFns } from "./CancelInviteAdminAccountDialog.vue?vue&type=template&id=ca31efe8"
import script from "./CancelInviteAdminAccountDialog.vue?vue&type=script&lang=js"
export * from "./CancelInviteAdminAccountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports